import { FC } from "react";
import { Backdrop } from "@material-ui/core";
import { LogoSolar } from "src/framework/components/commons";
import { isLoading$ } from "src/framework/store";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Icon } from "@material-ui/core";
import { orange } from "@material-ui/core/colors";
import "./style.css";
import { Grid } from "@material-ui/core";
import { useObservable } from "src/framework/store/storeUtil";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.modal + 20,
      backgroundColor: "rgba(255,255,255,0.74)",
    },
  })
);

const Loader: FC = () => {
  const classes = useStyles();
  const isLoading = useObservable(isLoading$)

  return (
    <div>
      <Backdrop open={isLoading} className={classes.backdrop}>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Icon
              className="spin"
              style={{ fontSize: "40px", color: orange[500] }}
            >
              wb_sunny
            </Icon>
          </Grid>
          <Grid item>
            <LogoSolar fillIntelbras={"#00B26B"} width={"200px"} />
          </Grid>
        </Grid>
      </Backdrop>
    </div>
  );
};

export { Loader };
